export enum RestartMode {
  arc = 'arc',
  os = 'os',
}
